import { Component } from '@angular/core';

@Component({
  selector: 'app-bad-request',
  templateUrl: './bad-request.component.html',
  styleUrls: ['./bad-request.component.css']
})
export class BadRequestComponent {
  titulo: string = '¡Lo sentimos!'
  subTitulo: string = 'No podemos encontrar la página que estas buscando.'
  subTituloDos: string = 'Pero tranqui podemos ayudarte a retomar tu camino.'
}
